export default "__VITE_ASSET__BKJJL31n__"